import { observable } from "mobx";
import { Type } from "class-transformer";
import ChargeOrderInstructionType from "./chargeOrderInstructionType";
import FuelTypeLimitationResponse from "./fuelTypeLimitationResponse";
import VehicleRegistrationResponse from "./vehicleRegistrationResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ChargeOrderInstructionGroupResponse {
  @observable
  instructionType!: ChargeOrderInstructionType;

  /**
   * Possible exemption reason IDs.
   */
  @observable
  possibleExemptionReasonIds?: string[];

  @observable
  @Type(() => FuelTypeLimitationResponse)
  fuelTypeLimitation?: FuelTypeLimitationResponse;

  /**
   * The list of vehicles for which the instruction is relevant.
   */
  @observable
  @Type(() => VehicleRegistrationResponse)
  vehicles?: VehicleRegistrationResponse[];
}
